"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext } from "react";
const BetslipGeoContext = createContext<boolean>(false);
export function BetslipGeoProvider(t0) {
  const $ = _c(3);
  const {
    isGeoBlocked,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== isGeoBlocked) {
    t1 = <BetslipGeoContext.Provider value={isGeoBlocked}>{children}</BetslipGeoContext.Provider>;
    $[0] = children;
    $[1] = isGeoBlocked;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useBetslipGeoBlocked() {
  return useContext(BetslipGeoContext);
}